import React, { useEffect, useMemo } from "react"
import { Switch, Route, useLocation } from "react-router-dom"
import PrivateRoute from './PrivateRoute'
import Login from "./pages/Login"
import AutoLogin from "./pages/Autologin"
import Visualization from './pages/visualization/components/Visualization'
import ResetPassword from './pages/ResetPassword'
import UserSettingsPage from './pages/UserSettings'
import Dashboard from './pages/Dashboard'
import Watchlist from './pages/Watchlist'
import Admin from './pages/admin/AdminIndex'
import TermsOfUse from './pages/TermsOfUse'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Disclaimer from './pages/Disclaimer'
import Screener from './components/screnner/components/Screener'
import RouteErrorPage from "./components/RouteErrorPage"
import ReportPage from "./pages/reports/components/ReportPage"
import MultiStocks from "./components/multipleStocks-analysis/MultiStocks"
import { useGeneral } from "./context/general"
import useUser from "./hooks/useUser"
// import EDADashboard from "./pages/EDA_Dashboard/EDADashboard"
import EDADashboard from './pages/EDA/Main'

export default function Routes() {
    const { setAutoLoginStatus } = useGeneral()
    const location = useLocation()
    const { pathname } = location
    const { isLoggedIn } = useUser()

    useEffect(()=>{
        setAutoLoginStatus(pathname.includes('autologinfromAlthub')?true:false)
        return () => {}
    },[location])

    return (
        <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/resetPassword" component={ResetPassword} />
            <Route exact path="/termsOfUse" component={TermsOfUse} />
            <Route exact path="/privacyPolicy" component={PrivacyPolicy} />
            <Route exact path="/disclaimer" component={Disclaimer} />
            <Route exact path="/autologinfromAlthub" component={AutoLogin} />
            <PrivateRoute path="/visualization" component={Visualization} />
            <PrivateRoute path="/userSettings" component={UserSettingsPage} />
            <PrivateRoute path="/dashboard" component={Dashboard} />
            <PrivateRoute path="/studio" component={ReportPage} />
            <PrivateRoute path="/watchlist" component={Watchlist} />
            <PrivateRoute path="/screener" component={Screener} />
            <PrivateRoute path="/multistocks" component={MultiStocks} />
            <PrivateRoute path="/adminpanel" admin={true} component={Admin} />
            <PrivateRoute exact path="/" component={Dashboard} />
            <PrivateRoute path="/EDA-Dashboard" component={EDADashboard} />
            <Route component={RouteErrorPage}/>
        </Switch>
    )
}
